import { useContext, useEffect, useState } from "react";
import QuestContext from "../../../../components/QuestWrapper";
import { LeaderboardCupSvg } from "./LeaderboardSvg";
import { LeaderBoardCardProps, LevelValues, MemberShipProp } from "./leaderBoardTypes";
import config from "../../../../config";
import { questLogo } from "../../../../assets/images";
import LeaderboardThemeManager from "./LeaderboardThemeManager";

const calculateLevel = (points: number): LevelValues => {
  if (points < 1) {
    return {
      currentLevel: 1,
      previousLevelthreshold: 0,
      currentLevelthreshold: 0,
    };
  }

  const currentLevel = Math.max(1, Math.ceil(Math.log2(points / 250) + 1));
  const previousLevelthreshold = (currentLevel - 1) * 250;

  return {
    currentLevel,
    previousLevelthreshold,
    currentLevelthreshold: 0,
  };
};

const calculateActualMemberShip = (
  memberShip: MemberShipProp[],
  item: any
): LevelValues => {
  let indexValue = -1;

  const find = memberShip?.find((val, index) => {
    if (val?.xpThreshold && item?.runningXP && val.xpThreshold >= item.runningXP) {
      indexValue = index;
      return true;
    }
    return false;
  });

  let currentLevel = 0;
  let previousLevelthreshold = 0;
  let currentLevelthreshold = 0;

  if (find || (indexValue === -1 && memberShip.length > 0)) {
    if (find) {
      currentLevel = find.membershipTier;
      if (indexValue > 0) {
        previousLevelthreshold = memberShip[indexValue - 1].xpThreshold;
      }
      currentLevelthreshold = memberShip[indexValue].xpThreshold;
    } else {
      currentLevel = memberShip[0].membershipTier;
      currentLevelthreshold = memberShip[0].xpThreshold;
    }
  }

  return {
    currentLevel,
    previousLevelthreshold,
    currentLevelthreshold,
  };
};

const LeaderBoardCard: React.FC<LeaderBoardCardProps> = ({
  index,
  item,
  memberShip,
  styleConfig,
  isXpImage,
  presentUserRank,
  DefaultImage,
  brandTheme,
  questThemeData,
  onUserClick,
  customUnit
}) => {
  const [updatedItem, setUpdatedItem] = useState(item);
  const { themeConfig } = useContext(QuestContext.Context);
  
  const themeManager = new LeaderboardThemeManager(
    themeConfig,
    styleConfig,
    questThemeData,
    brandTheme
  );

  useEffect(() => {
    if (updatedItem?.imageUrl && !updatedItem.imageUrl.includes("http")) {
      const newItem = {
        ...updatedItem,
        imageUrl: `${config.BASE_IPFS_URL}${updatedItem.imageUrl}`,
      };
      setUpdatedItem(newItem);
    }
  }, [updatedItem]);

  let progressBarWidth = 0;

  if (memberShip.length > 0) {
    const { previousLevelthreshold, currentLevelthreshold } = calculateActualMemberShip(memberShip, item);
    progressBarWidth = ((item.runningXP - previousLevelthreshold) / currentLevelthreshold) * 100;
  } else {
    const { previousLevelthreshold } = calculateLevel(item.runningXP);
    progressBarWidth = ((item.runningXP - previousLevelthreshold) /
      (previousLevelthreshold === 0 ? 250 : previousLevelthreshold)) * 100;
  }

  const cardStyles = themeManager.getLeaderboardCardStyles(presentUserRank == index + 4);

  return (
    <>
      <div
        className={`q_leaderboardcard_main_cont ${
          presentUserRank === index + 4 ? "q_present_user_cont" : ""
        }`}
        style={cardStyles.container}
        onClick={() => onUserClick && onUserClick(item)}
      >
        <div
          className="q_count_base"
          style={cardStyles.index}
        >
          {index + 4}
        </div>

        <img
          className="q_profile_cont"
          src={item.imageUrl ? item.imageUrl : DefaultImage || questLogo}
          alt="logo"
        />
        
        <div className="q_name_cont">
          <div className="q_name_small_cont">
            <div
              className="q_leaderboardcard_name_head"
              style={cardStyles.name}
            >
              {item.name ?? "Quest User"}
            </div>
            {LeaderboardCupSvg(cardStyles.icon.color)}
          </div>

          <div className="q_leaderboardcard_progressbar">
            <div
              className="LeaderBoardCardProgressBarinner"
              style={{
                width: `${progressBarWidth}%`,
                ...cardStyles.progressBar
              }}
            />
          </div>
          
          <div
            className="q_leaderboardcard_points"
            style={cardStyles.points}
          >
            {item.runningXP || 0} {isXpImage ? "XP" : customUnit || "Points"}
          </div>
        </div>
      </div>
      <div className="q_leaderboardcard_divider" />
    </>
  );
};

export default LeaderBoardCard;



